import { Helmet } from "react-helmet-async";

const BASE = "https://anayafashion.store";

// Per-route SEO. Helmet is the sole owner of title/description/canonical/robots to avoid
// duplicate tags; the static head in index.html stays as the no-JS crawler/share-scraper floor.
export function Seo({ title, description, path = "/", noindex = false, jsonLd }) {
  const url = BASE + (path.startsWith("/") ? path : `/${path}`);
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {!noindex && <link rel="canonical" href={url} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
